import { makeStyles } from 'tss-react/mui';

import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';

const useStyles = makeStyles({ name: 'MuiHeroTwoThirdsImage' })(
  ({ type, brandColors, breakpoints, typography }) => ({
    heroContainer: {
      marginTop: typography.pxToRem(0),
      color: brandColors.white,
      background: `linear-gradient(180deg, ${brandColors.primaryMain} 0%, ${brandColors.mediumBlue} 100%)`,
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        background: `linear-gradient(180deg, ${brandColors.mediumBlue} 0%, ${brandColors.primaryMain} 100%)`,
      },
    },
    heroSection: {
      aspectRatio: '1440 / 908',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        maxHeight: typography.pxToRem(250),
      },
    },
    heroTextContainer: {
      aspectRatio: '1440 / 908',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      display: 'flow-root',
      alignItems: 'center',
      paddingLeft: typography.pxToRem(30),
      paddingRight: typography.pxToRem(30),
      maxHeight: typography.pxToRem(480),
      margin: 'auto',
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        paddingLeft: typography.pxToRem(20),
        alignItems: 'unset',
        paddingTop: typography.pxToRem(32),
        paddingBottom: typography.pxToRem(48),
      },
    },
    heroTextContainerNoCTA: {
      aspectRatio: '1440 / 908',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      display: 'flex',
      alignItems: 'center',
      paddingLeft: typography.pxToRem(30),
      paddingRight: typography.pxToRem(30),
      maxHeight: typography.pxToRem(480),
      margin: 'auto',
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        paddingLeft: typography.pxToRem(20),
        display: 'flex',
        alignItems: 'center',
        paddingTop: typography.pxToRem(32),
        paddingBottom: typography.pxToRem(48),
      },
    },
    heroTitle: {
      ...type['64_medium'],
      textWrap: 'pretty',
      color: brandColors.white,
      paddingBottom: typography.pxToRem(20),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...type['44_medium'],
      },
    },
    heroBody: {
      ...type['20_regular'],
      color: brandColors.white,
      paddingBottom: typography.pxToRem(20),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...type['16_medium'],
      },
    },
    heroButtom: {
      paddingBottom: typography.pxToRem(20),
    },
  })
);

export default useStyles;
